module.exports = __webpack_public_path__ + "img/traills.f233dc45.jpg";